import { useContext } from "react";
import { ThemeContext } from "styled-components/native";

import { Theme } from "../types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useTheme = (): Theme => useContext(ThemeContext as any) as Theme;

export default useTheme;
